<div fxLayout='row' class='report-data-multi-nav-container' *ngIf='dataNavVisible && navigationFilters?.length'>
  <div fxFlex class='nav-data-dropdown-container'>
    <div fxFlex fxLayout='row' fxLayoutAlign='left' style='color: white'>
      <div *ngFor='let navigationFilter of navigationFilters; let i = index'>
        <button
          class='dropdown-button'
          type='button'
          mat-button
          [matMenuTriggerFor]='subReportFilters'
          style='text-align: left'
        >
					<span style='position: relative; bottom: 1px'>
						{{
            cService.readyTranslations.navigationFilter[navigationFilter.text]
              ? cService.readyTranslations.navigationFilter[navigationFilter.text]
              : navigationFilter.text
            }}:

            {{
            cService.readyTranslations.navigationFilter[navigationFilter.selected.text]
              ? cService.readyTranslations.navigationFilter[navigationFilter.selected.text]
              : navigationFilter.selected.text
            }}
					</span>
          <mat-icon style='position: relative; bottom: 2px'>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #subReportFilters='matMenu' [overlapTrigger]='false'>
          <button
            mat-menu-item
            *ngFor='let filterOption of navigationFilter.options'
            [value]='filterOption.value'
            (click)='dataFilterChanged(navigationFilter, filterOption)'
            [class.bold]='filterOption.value === navigationFilter.selected.value'
          >
            {{
            cService.readyTranslations.navigationFilter[filterOption.text]
              ? cService.readyTranslations.navigationFilter[filterOption.text]
              : filterOption.text
            }}
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
